// hooks
import { useTranslation } from 'react-i18next';

// utils
import { getHoursAndMinutesFromHours } from 'utils/date';

/** a working day may legally not exceed 12 hours */
export const MAX_HOURS_PER_DAY = 12;

/** hours booked per checked working day */
export const hoursPerDay = (
  weekHours: number,
  dayCount: number,
  percentage = 100
) => (dayCount > 0 ? (weekHours * percentage) / 100 / dayCount : 0);

/** "3,75" hours → "3 uur 45 min", so a working day directly reads as time */
export const useFormatHoursPerDay = () => {
  const { t } = useTranslation('common');

  return (value: number) => {
    const { h: hours, m: minutes } = getHoursAndMinutesFromHours(value);
    const hourPart = hours
      ? `${hours} ${t('reactRegisterAbsence.hourShort')}`
      : '';
    const minutePart = minutes
      ? `${minutes} ${t('reactRegisterAbsence.minuteShort')}`
      : '';
    return [hourPart, minutePart].filter(Boolean).join(' ');
  };
};
